import { makeElement } from "../../../common/Utils";
import l10n from "../../L10n";
import { copyText } from "../../Utils";
import { AbsSocial } from "./AbsSocial";
import Modal from '../../../md-modal';
import { ga360 } from '../socials/GA360';
import Toast from "../../../md-modal/Notification/Toast";

// import Toast
export class CopyText extends AbsSocial {
    name: SocialName = 'copy';
    modalToast: Toast;
    dataContents = ga360.dataContents.copy;
    dataArea = ga360.dataArea.common;
    successToast = true;

    constructor(protected ElShareItemWrap: HTMLElement, protected option: ShareOption){
        super(ElShareItemWrap, option);
        this.modalToast = new Modal.uiToast();

        // useSuccessToast 가 명시적으로 false인 경우에만 useSuccessToast를 false로 설정
        if(this.option.useSuccessToast === false) {
          this.successToast = false;
        };
        
        this.init();
    }

    async callShare(){
      await copyText(this.option.shareUrl);
      this.successToast && this.modalToast.open({
          title: this.option.copySuccessMsg ?? l10n[this.option.langCode].successMsg,
          showCloseButton: false,
          showConfirmButton: false,
          showCancelButton: false,
          customClass: 'share-toast',
          timer: 1000,
      });
    }
    
}
